var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetaCima(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "306pt",
    height: "307pt",
    viewBox: "0 0 306 307",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#d9d9d9ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "#226affff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#226aff",
    opacity: 1,
    d: " M 60.36 35.19 C 83.37 17.15 111.81 6.20 140.96 4.01 C 176.98 1.15 214.08 11.69 242.77 33.75 C 236.17 35.20 229.42 33.10 222.76 34.16 C 198.01 19.59 168.66 13.11 140.07 15.74 C 118.33 17.68 97.06 24.82 78.59 36.48 C 72.62 34.71 66.37 36.73 60.36 35.19 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "#2f64ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2f64ff",
    opacity: 1,
    d: " M 72.46 55.27 C 92.52 38.62 118.01 28.80 143.97 27.05 C 175.14 24.91 207.18 34.56 231.47 54.31 C 225.97 56.64 219.87 54.20 214.26 56.14 C 193.81 43.17 169.20 37.00 145.06 38.62 C 126.48 39.81 108.20 45.56 92.32 55.28 C 85.70 55.08 79.07 55.95 72.46 55.27 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "#3462ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3462ff",
    opacity: 1,
    d: " M 222.76 34.16 C 229.42 33.10 236.17 35.20 242.77 33.75 L 243.00 33.71 C 253.71 41.93 263.76 51.24 271.67 62.24 C 267.08 62.62 262.51 63.11 257.93 63.45 C 247.97 51.79 235.91 42.00 222.76 34.16 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "#3561ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3561ff",
    opacity: 1,
    d: " M 31.29 64.88 C 39.56 53.73 49.33 43.63 60.36 35.19 C 66.37 36.73 72.62 34.71 78.59 36.48 C 66.19 44.39 54.92 54.10 45.54 65.45 C 40.79 65.15 35.98 65.90 31.29 64.88 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "#3f5dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3f5dff",
    opacity: 1,
    d: " M 231.47 54.31 L 231.71 54.23 C 240.62 61.59 248.96 69.79 255.60 79.29 C 251.13 80.70 246.44 80.57 241.84 80.31 C 233.94 70.90 224.63 62.71 214.26 56.14 C 219.87 54.20 225.97 56.64 231.47 54.31 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f5dff",
    opacity: 1,
    d: " M 72.25 55.25 L 72.46 55.27 C 79.07 55.95 85.70 55.08 92.32 55.28 C 81.35 62.07 71.34 70.51 63.20 80.54 C 58.63 79.69 53.87 81.01 49.45 79.35 C 55.94 70.35 63.65 62.25 72.25 55.25 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "#435bffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#435bff",
    opacity: 1,
    d: " M 257.93 63.45 C 262.51 63.11 267.08 62.62 271.67 62.24 L 272.03 62.21 C 277.43 69.53 282.49 77.14 286.63 85.25 C 285.89 86.08 284.99 86.76 283.82 86.53 C 280.50 86.40 277.18 86.04 273.86 86.00 C 269.28 78.00 263.95 70.43 257.93 63.45 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "#445bffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#445bff",
    opacity: 1,
    d: " M 17.43 87.36 C 21.47 79.53 26.00 71.93 31.29 64.88 C 35.98 65.90 40.79 65.15 45.54 65.45 C 39.82 72.42 34.68 79.87 30.33 87.77 C 26.04 87.34 21.73 87.49 17.43 87.36 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "#78c5ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#78c5ff",
    opacity: 1,
    d: " M 147.27 74.31 C 152.74 71.72 159.92 73.60 163.25 78.70 C 166.14 83.22 169.11 87.69 171.77 92.35 C 166.96 94.65 161.39 93.12 156.26 93.05 C 148.68 93.38 140.93 94.00 133.46 92.35 C 135.64 88.29 138.31 84.52 140.68 80.58 C 142.26 77.95 144.34 75.46 147.27 74.31 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "#4c57ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4c57ff",
    opacity: 1,
    d: " M 36.60 101.42 C 39.99 93.60 44.38 86.20 49.45 79.35 C 53.87 81.01 58.63 79.69 63.20 80.54 C 57.71 87.17 52.94 94.39 49.06 102.07 C 44.92 101.70 40.76 101.57 36.60 101.42 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "#4c58ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4c58ff",
    opacity: 1,
    d: " M 255.60 79.29 L 255.77 79.25 C 260.60 86.04 264.88 93.22 268.40 100.78 C 264.28 101.47 260.11 101.56 255.95 101.73 C 252.09 94.08 247.27 86.93 241.84 80.31 C 246.44 80.57 251.13 80.70 255.60 79.29 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "#5355ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5355ff",
    opacity: 1,
    d: " M 286.63 85.25 C 292.23 95.88 296.28 107.25 299.24 118.87 C 295.29 118.97 291.34 119.16 287.40 119.48 C 284.43 107.77 279.73 96.54 273.86 86.00 C 277.18 86.04 280.50 86.40 283.82 86.53 C 284.99 86.76 285.89 86.08 286.63 85.25 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "#5056ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5056ff",
    opacity: 1,
    d: " M 10.39 104.43 C 12.14 98.51 14.82 92.93 17.43 87.36 C 21.73 87.49 26.04 87.34 30.33 87.77 C 27.27 93.36 24.62 99.17 22.36 105.13 C 18.36 105.20 14.35 105.03 10.39 104.43 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "#87c1ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87c1ff",
    opacity: 1,
    d: " M 133.17 92.29 L 133.46 92.35 C 140.93 94.00 148.68 93.38 156.26 93.05 C 161.39 93.12 166.96 94.65 171.77 92.35 L 171.95 92.27 C 176.84 100.02 181.73 107.77 186.64 115.50 C 179.68 117.58 172.25 115.44 165.10 116.25 C 149.62 115.70 134.08 117.13 118.64 115.58 C 123.28 107.70 128.44 100.12 133.17 92.29 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "#5753ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5753ff",
    opacity: 1,
    d: " M 36.33 101.41 L 36.60 101.42 C 40.76 101.57 44.92 101.70 49.06 102.07 C 46.40 107.29 44.11 112.70 42.31 118.28 C 38.34 118.89 34.20 119.59 30.30 118.21 C 31.73 112.42 34.17 106.95 36.33 101.41 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "#5853ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5853ff",
    opacity: 1,
    d: " M 255.95 101.73 C 260.11 101.56 264.28 101.47 268.40 100.78 C 271.31 106.87 273.55 113.27 275.46 119.74 C 271.35 119.32 267.21 119.71 263.12 119.14 C 261.26 113.14 258.80 107.33 255.95 101.73 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "#5952ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5952ff",
    opacity: 1,
    d: " M 10.22 104.41 L 10.39 104.43 C 14.35 105.03 18.36 105.20 22.36 105.13 C 20.19 110.74 18.48 116.51 17.07 122.35 C 13.19 123.03 9.02 123.49 5.40 121.57 C 6.54 115.73 8.40 110.07 10.22 104.41 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "#99bdffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#99bdff",
    opacity: 1,
    d: " M 118.38 115.55 L 118.64 115.58 C 134.08 117.13 149.62 115.70 165.10 116.25 C 172.25 115.44 179.68 117.58 186.64 115.50 C 190.36 121.13 193.89 126.89 197.51 132.59 C 200.76 136.26 198.17 142.81 193.13 142.72 C 185.44 143.02 177.74 142.64 170.04 142.89 C 169.99 144.30 169.95 145.71 169.91 147.12 C 165.49 147.37 161.05 147.75 156.65 147.24 C 150.10 146.18 143.52 147.65 136.95 147.31 C 136.33 145.82 135.70 144.34 135.08 142.86 C 127.38 142.66 119.68 143.03 111.99 142.70 C 108.96 142.69 106.36 140.07 106.24 137.08 C 105.96 134.94 107.38 133.15 108.37 131.41 C 111.76 126.16 115.08 120.86 118.38 115.55 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "#614fffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#614fff",
    opacity: 1,
    d: " M 30.11 118.16 L 30.30 118.21 C 34.20 119.59 38.34 118.89 42.31 118.28 C 40.45 123.99 39.03 129.83 38.05 135.76 C 34.15 135.56 30.26 135.51 26.37 135.23 C 27.21 129.46 28.64 123.80 30.11 118.16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#614fff",
    opacity: 1,
    d: " M 263.12 119.14 C 267.21 119.71 271.35 119.32 275.46 119.74 C 276.56 124.73 278.52 129.87 278.34 134.91 C 274.65 135.55 270.86 135.33 267.19 136.10 C 266.27 130.36 264.90 124.68 263.12 119.14 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "#614effff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#614eff",
    opacity: 1,
    d: " M 287.40 119.48 C 291.34 119.16 295.29 118.97 299.24 118.87 C 300.52 124.45 301.57 130.09 302.34 135.77 C 298.41 135.51 294.48 135.55 290.55 135.32 C 289.82 129.98 288.71 124.71 287.40 119.48 Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "#634effff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#634eff",
    opacity: 1,
    d: " M 5.24 121.51 L 5.40 121.57 C 9.02 123.49 13.19 123.03 17.07 122.35 C 15.76 127.86 14.82 133.47 14.17 139.10 C 10.28 139.30 6.39 139.18 2.50 138.97 C 3.10 133.10 4.19 127.30 5.24 121.51 Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "#6b4affff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6b4aff",
    opacity: 1,
    d: " M 26.37 135.23 C 30.26 135.51 34.15 135.56 38.05 135.76 C 37.14 141.42 36.65 147.15 36.56 152.89 C 32.70 153.09 28.84 153.25 24.98 153.30 C 24.99 147.25 25.54 141.22 26.37 135.23 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4aff",
    opacity: 1,
    d: " M 267.19 136.10 C 270.86 135.33 274.65 135.55 278.34 134.91 L 278.81 134.84 C 279.63 140.85 280.11 146.91 280.28 152.98 C 276.38 152.81 272.47 153.00 268.63 153.73 C 268.61 147.82 268.07 141.93 267.19 136.10 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b4aff",
    opacity: 1,
    d: " M 290.55 135.32 C 294.48 135.55 298.41 135.51 302.34 135.77 C 302.97 141.51 303.37 147.28 303.44 153.07 C 299.58 153.01 295.72 152.97 291.86 152.96 C 291.76 147.06 291.32 141.17 290.55 135.32 Z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "#6d49ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6d49ff",
    opacity: 1,
    d: " M 2.50 138.97 C 6.39 139.18 10.28 139.30 14.17 139.10 C 13.51 145.32 13.25 151.58 13.39 157.84 C 9.51 157.91 5.64 158.21 1.75 158.11 C 1.64 151.72 1.90 145.33 2.50 138.97 Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "#b2b7ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b7ff",
    opacity: 1,
    d: " M 135.08 142.86 C 135.70 144.34 136.33 145.82 136.95 147.31 C 143.52 147.65 150.10 146.18 156.65 147.24 C 161.05 147.75 165.49 147.37 169.91 147.12 C 170.18 160.06 169.89 173.00 169.91 185.94 C 162.85 185.96 155.80 185.56 148.74 185.66 C 144.64 185.84 140.52 185.91 136.44 185.48 C 136.05 184.20 135.66 182.91 135.32 181.62 C 134.98 168.71 135.07 155.78 135.08 142.86 Z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "#7546ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7546ff",
    opacity: 1,
    d: " M 24.98 153.30 C 28.84 153.25 32.70 153.09 36.56 152.89 C 36.50 159.00 36.87 165.12 37.76 171.16 C 34.20 173.26 29.59 173.14 25.96 171.28 C 25.37 165.30 24.85 159.31 24.98 153.30 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7546ff",
    opacity: 1,
    d: " M 268.63 153.73 C 272.47 153.00 276.38 152.81 280.28 152.98 C 280.26 159.30 279.89 165.61 279.06 171.87 C 275.16 172.38 271.17 173.24 267.27 172.22 C 268.20 166.10 268.68 159.91 268.63 153.73 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7546ff",
    opacity: 1,
    d: " M 291.86 152.96 C 295.72 152.97 299.58 153.01 303.44 153.07 C 303.46 159.42 303.18 165.77 302.41 172.08 C 298.47 172.14 294.54 172.41 290.63 172.86 C 291.48 166.26 291.89 159.61 291.86 152.96 Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "#7845ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7845ff",
    opacity: 1,
    d: " M 1.75 158.11 C 5.64 158.21 9.51 157.91 13.39 157.84 C 13.57 164.55 14.18 171.26 15.33 177.88 C 11.37 177.78 7.40 177.85 3.46 177.44 C 2.52 171.03 1.97 164.58 1.75 158.11 Z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "#8041ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8041ff",
    opacity: 1,
    d: " M 25.96 171.28 C 29.59 173.14 34.20 173.26 37.76 171.16 C 38.62 177.24 40.02 183.23 41.82 189.09 C 38.10 190.97 33.93 190.46 29.96 190.00 C 28.19 183.86 27.01 177.58 25.96 171.28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8041ff",
    opacity: 1,
    d: " M 263.25 189.50 C 264.97 183.83 266.38 178.07 267.27 172.22 C 271.17 173.24 275.16 172.38 279.06 171.87 C 278.22 177.98 276.90 184.02 275.21 189.95 C 271.22 189.97 267.22 189.94 263.25 189.50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8041ff",
    opacity: 1,
    d: " M 290.63 172.86 C 294.54 172.41 298.47 172.14 302.41 172.08 C 301.67 178.48 300.48 184.82 298.97 191.08 C 294.92 191.92 290.79 192.47 286.66 192.19 C 288.41 185.85 289.74 179.38 290.63 172.86 Z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "#8340ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8340ff",
    opacity: 1,
    d: " M 3.46 177.44 C 7.40 177.85 11.37 177.78 15.33 177.88 C 16.40 184.08 17.86 190.21 19.74 196.21 C 15.97 198.29 11.72 196.69 7.71 196.48 C 5.85 190.24 4.53 183.85 3.46 177.44 Z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "#c8b2ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8b2ff",
    opacity: 1,
    d: " M 135.32 181.62 C 135.66 182.91 136.05 184.20 136.44 185.48 C 140.52 185.91 144.64 185.84 148.74 185.66 C 155.80 185.56 162.85 185.96 169.91 185.94 C 170.09 194.27 170.04 202.61 169.94 210.94 C 161.55 212.03 153.10 210.90 144.69 211.29 C 141.52 211.44 138.34 211.44 135.17 211.17 C 135.22 201.32 134.83 191.46 135.32 181.62 Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "#8a3dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a3dff",
    opacity: 1,
    d: " M 41.82 189.09 C 43.85 195.51 46.47 201.73 49.57 207.71 C 45.32 208.00 41.05 208.02 36.79 207.68 L 36.39 207.66 C 34.09 201.83 31.71 196.02 29.96 190.00 C 33.93 190.46 38.10 190.97 41.82 189.09 Z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "#893dffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#893dff",
    opacity: 1,
    d: " M 263.25 189.50 C 267.22 189.94 271.22 189.97 275.21 189.95 C 273.44 195.67 271.52 201.37 268.97 206.80 C 264.84 206.12 260.66 206.12 256.50 206.04 C 259.15 200.70 261.44 195.18 263.25 189.50 Z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "#8b3cffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8b3cff",
    opacity: 1,
    d: " M 286.66 192.19 C 290.79 192.47 294.92 191.92 298.97 191.08 C 297.16 198.10 294.91 204.99 292.17 211.69 C 288.90 211.42 285.64 211.81 282.38 211.64 C 281.74 210.86 281.14 210.05 280.58 209.21 C 283.02 203.70 284.97 197.98 286.66 192.19 Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "#8e3bffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8e3bff",
    opacity: 1,
    d: " M 7.71 196.48 C 11.72 196.69 15.97 198.29 19.74 196.21 C 21.93 203.10 24.63 209.83 27.86 216.30 C 23.84 217.45 19.63 217.39 15.48 217.40 C 12.48 210.59 9.70 203.66 7.71 196.48 Z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "#9239ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9239ff",
    opacity: 1,
    d: " M 246.53 222.50 C 250.31 217.31 253.60 211.77 256.50 206.04 C 260.66 206.12 264.84 206.12 268.97 206.80 C 266.29 212.70 263.21 218.44 259.62 223.85 C 259.30 223.50 258.64 222.81 258.31 222.46 C 254.40 222.00 250.45 222.63 246.53 222.50 Z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "#9439ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9439ff",
    opacity: 1,
    d: " M 36.79 207.68 C 41.05 208.02 45.32 208.00 49.57 207.71 C 52.66 213.87 56.47 219.64 60.62 225.13 C 56.08 226.11 51.43 225.66 46.83 225.85 C 42.99 220.09 39.42 214.10 36.79 207.68 Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "#9638ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9638ff",
    opacity: 1,
    d: " M 270.09 229.13 C 274.14 222.80 277.52 216.07 280.58 209.21 C 281.14 210.05 281.74 210.86 282.38 211.64 C 285.64 211.81 288.90 211.42 292.17 211.69 C 289.47 218.29 286.10 224.57 282.74 230.85 L 282.55 230.81 C 278.43 230.00 274.26 229.55 270.09 229.13 Z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "#daaeffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#daaeff",
    opacity: 1,
    d: " M 135.17 211.17 C 138.34 211.44 141.52 211.44 144.69 211.29 C 153.10 210.90 161.55 212.03 169.94 210.94 C 169.95 217.31 170.15 223.69 169.93 230.06 C 169.96 233.12 167.13 235.85 164.06 235.64 C 156.34 235.69 148.62 235.67 140.90 235.63 C 137.83 235.82 135.14 233.05 135.21 230.03 C 134.94 223.75 135.15 217.46 135.17 211.17 Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "#a133ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a133ff",
    opacity: 1,
    d: " M 27.86 216.30 C 36.33 233.43 48.50 248.61 63.01 261.01 C 57.73 261.34 52.26 259.97 47.25 262.22 C 33.95 249.46 23.29 234.06 15.48 217.40 C 19.63 217.39 23.84 217.45 27.86 216.30 Z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "#9c35ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9c35ff",
    opacity: 1,
    d: " M 246.53 222.50 C 250.45 222.63 254.40 222.00 258.31 222.46 C 258.64 222.81 259.30 223.50 259.62 223.85 C 255.35 230.63 250.19 236.78 244.84 242.72 L 244.66 242.66 C 239.69 240.50 234.16 241.45 228.93 241.74 C 235.51 236.03 241.38 229.53 246.53 222.50 Z"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "#9d35ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9d35ff",
    opacity: 1,
    d: " M 46.83 225.85 C 51.43 225.66 56.08 226.11 60.62 225.13 C 65.35 231.20 70.61 236.87 76.42 241.92 C 71.14 243.03 65.75 241.35 60.46 242.50 L 60.32 242.52 C 55.34 237.37 50.87 231.75 46.83 225.85 Z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "#a531ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a531ff",
    opacity: 1,
    d: " M 241.21 261.80 C 252.42 252.45 262.22 241.42 270.09 229.13 C 274.26 229.55 278.43 230.00 282.55 230.81 C 275.61 242.93 266.72 253.91 256.58 263.50 C 251.70 261.12 246.24 263.46 241.21 261.80 Z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "#a730ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a730ff",
    opacity: 1,
    d: " M 228.93 241.74 C 234.16 241.45 239.69 240.50 244.66 242.66 C 237.92 250.03 229.96 256.18 221.70 261.75 L 221.48 261.71 C 214.30 259.56 206.86 261.58 199.56 260.58 C 210.21 255.79 220.15 249.43 228.93 241.74 Z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "#a830ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a830ff",
    opacity: 1,
    d: " M 60.46 242.50 C 65.75 241.35 71.14 243.03 76.42 241.92 C 85.35 249.66 95.41 256.09 106.24 260.82 C 98.66 261.54 91.03 260.42 83.49 261.50 C 74.96 256.40 67.23 249.79 60.46 242.50 Z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "#b32bffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b32bff",
    opacity: 1,
    d: " M 83.49 261.50 C 91.03 260.42 98.66 261.54 106.24 260.82 C 135.59 273.79 170.27 273.59 199.56 260.58 C 206.86 261.58 214.30 259.56 221.48 261.71 C 180.84 288.81 123.99 288.87 83.49 261.50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b32bff",
    opacity: 1,
    d: " M 207.61 282.40 C 219.66 277.05 231.02 270.16 241.21 261.80 C 246.24 263.46 251.70 261.12 256.58 263.50 C 248.80 271.08 240.11 277.75 230.82 283.36 L 230.62 283.31 C 223.08 281.44 215.28 282.70 207.61 282.40 Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "#b52affff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b52aff",
    opacity: 1,
    d: " M 47.25 262.22 C 52.26 259.97 57.73 261.34 63.01 261.01 C 76.38 272.18 91.78 280.89 108.28 286.50 C 103.83 286.67 99.35 286.83 94.94 287.52 C 92.60 287.74 91.74 290.27 90.43 291.85 C 74.48 284.58 59.69 274.60 47.25 262.22 Z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "#c025ffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c025ff",
    opacity: 1,
    d: " M 207.61 282.40 C 215.28 282.70 223.08 281.44 230.62 283.31 C 189.21 309.28 134.75 312.29 90.43 291.85 C 91.74 290.27 92.60 287.74 94.94 287.52 C 99.35 286.83 103.83 286.67 108.28 286.50 C 140.44 297.28 176.46 295.85 207.61 282.40 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaCima);
export default __webpack_public_path__ + "static/media/seta-cima.349c4fa461bb28acf0ec4b6dc45e3b64.svg";
export { ForwardRef as ReactComponent };